export default "__VITE_ASSET__0fi7vqmL__"